"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDOMNode = exports.getDOMNodeId = exports.setOuterHTML = exports.setNodeValue = exports.setInspectedNode = exports.setAttributeValue = exports.setAttributesAsText = exports.resolveNode = exports.requestNode = exports.requestChildNodes = exports.removeNode = exports.pushNodesByBackendIdsToFrontend = exports.discardSearchResults = exports.pushNodesToFrontend = exports.getSearchResults = exports.performSearch = exports.moveTo = exports.getOuterHTML = exports.getDocument = exports.enable = exports.copyTo = exports.collectClassNamesFromSubtree = void 0;
var connector_1 = __importDefault(require("../lib/connector"));
var nodeManager = __importStar(require("../lib/nodeManager"));
var nodeManager_1 = require("../lib/nodeManager");
var objManager = __importStar(require("../lib/objManager"));
var mutationObserver_1 = __importDefault(require("../lib/mutationObserver"));
var _1 = __importDefault(require("licia/$"));
var isNull_1 = __importDefault(require("licia/isNull"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var html_1 = __importDefault(require("licia/html"));
var map_1 = __importDefault(require("licia/map"));
var unique_1 = __importDefault(require("licia/unique"));
var contain_1 = __importDefault(require("licia/contain"));
var lowerCase_1 = __importDefault(require("licia/lowerCase"));
var each_1 = __importDefault(require("licia/each"));
var toArr_1 = __importDefault(require("licia/toArr"));
var xpath_1 = __importDefault(require("licia/xpath"));
var concat_1 = __importDefault(require("licia/concat"));
var evaluate_1 = require("../lib/evaluate");
var util_1 = require("../lib/util");
function collectClassNamesFromSubtree(params) {
    var node = nodeManager_1.getNode(params.nodeId);
    var classNames = [];
    traverseNode(node, function (node) {
        if (node.nodeType !== 1)
            return;
        var className = node.getAttribute('class');
        if (className) {
            var names = className.split(/\s+/);
            for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
                var name_1 = names_1[_i];
                classNames.push(name_1);
            }
        }
    });
    return {
        classNames: unique_1.default(classNames),
    };
}
exports.collectClassNamesFromSubtree = collectClassNamesFromSubtree;
function copyTo(params) {
    var nodeId = params.nodeId, targetNodeId = params.targetNodeId;
    var node = nodeManager_1.getNode(nodeId);
    var targetNode = nodeManager_1.getNode(targetNodeId);
    var cloneNode = node.cloneNode(true);
    targetNode.appendChild(cloneNode);
}
exports.copyTo = copyTo;
function enable() {
    mutationObserver_1.default.observe();
    nodeManager.clear();
}
exports.enable = enable;
function getDocument() {
    return {
        root: nodeManager.wrap(document, {
            depth: 2,
        }),
    };
}
exports.getDocument = getDocument;
function getOuterHTML(params) {
    var node = nodeManager_1.getNode(params.nodeId);
    return {
        outerHTML: node.outerHTML,
    };
}
exports.getOuterHTML = getOuterHTML;
function moveTo(params) {
    var nodeId = params.nodeId, targetNodeId = params.targetNodeId;
    var node = nodeManager_1.getNode(nodeId);
    var targetNode = nodeManager_1.getNode(targetNodeId);
    targetNode.appendChild(node);
}
exports.moveTo = moveTo;
var searchResults = new Map();
function performSearch(params) {
    var query = lowerCase_1.default(params.query);
    var result = [];
    try {
        result = concat_1.default(result, toArr_1.default(document.querySelectorAll(query)));
    }
    catch (e) {
    }
    try {
        result = concat_1.default(result, xpath_1.default(query));
    }
    catch (e) {
    }
    traverseNode(document, function (node) {
        var nodeType = node.nodeType;
        if (nodeType === 1) {
            var localName = node.localName;
            if (contain_1.default("<" + localName + " ", query) ||
                contain_1.default("</" + localName + ">", query)) {
                result.push(node);
                return;
            }
            var attributes_1 = [];
            each_1.default(node.attributes, function (_a) {
                var name = _a.name, value = _a.value;
                return attributes_1.push(name, value);
            });
            for (var i = 0, len = attributes_1.length; i < len; i++) {
                if (contain_1.default(lowerCase_1.default(attributes_1[i]), query)) {
                    result.push(node);
                    break;
                }
            }
        }
        else if (nodeType === 3) {
            if (contain_1.default(lowerCase_1.default(node.nodeValue), query)) {
                result.push(node);
            }
        }
    });
    var searchId = util_1.createId();
    searchResults.set(searchId, result);
    return {
        searchId: searchId,
        resultCount: result.length,
    };
}
exports.performSearch = performSearch;
function getSearchResults(params) {
    var searchId = params.searchId, fromIndex = params.fromIndex, toIndex = params.toIndex;
    var searchResult = searchResults.get(searchId);
    var result = searchResult.slice(fromIndex, toIndex);
    var nodeIds = map_1.default(result, function (node) {
        var nodeId = nodeManager_1.getNodeId(node);
        if (!nodeId) {
            return pushNodesToFrontend(node);
        }
        return nodeId;
    });
    return {
        nodeIds: nodeIds,
    };
}
exports.getSearchResults = getSearchResults;
function pushNodesToFrontend(node) {
    var nodes = [node];
    var parentNode = node.parentNode;
    while (parentNode) {
        nodes.push(parentNode);
        var nodeId = nodeManager_1.getNodeId(parentNode);
        if (nodeId) {
            break;
        }
        else {
            parentNode = parentNode.parentNode;
        }
    }
    while (nodes.length) {
        var node_1 = nodes.pop();
        var nodeId = nodeManager_1.getNodeId(node_1);
        connector_1.default.trigger('DOM.setChildNodes', {
            parentId: nodeId,
            nodes: nodeManager.getChildNodes(node_1, 1),
        });
    }
    return nodeManager_1.getNodeId(node);
}
exports.pushNodesToFrontend = pushNodesToFrontend;
function discardSearchResults(params) {
    searchResults.delete(params.searchId);
}
exports.discardSearchResults = discardSearchResults;
function pushNodesByBackendIdsToFrontend(params) {
    return {
        nodeIds: params.backendNodeIds,
    };
}
exports.pushNodesByBackendIdsToFrontend = pushNodesByBackendIdsToFrontend;
function removeNode(params) {
    var node = nodeManager_1.getNode(params.nodeId);
    _1.default(node).remove();
}
exports.removeNode = removeNode;
function requestChildNodes(params) {
    var nodeId = params.nodeId, _a = params.depth, depth = _a === void 0 ? 1 : _a;
    var node = nodeManager_1.getNode(nodeId);
    connector_1.default.trigger('DOM.setChildNodes', {
        parentId: nodeId,
        nodes: nodeManager.getChildNodes(node, depth),
    });
}
exports.requestChildNodes = requestChildNodes;
function requestNode(params) {
    var node = objManager.getObj(params.objectId);
    return {
        nodeId: nodeManager_1.getNodeId(node),
    };
}
exports.requestNode = requestNode;
function resolveNode(params) {
    var node = nodeManager_1.getNode(params.nodeId);
    return {
        object: objManager.wrap(node),
    };
}
exports.resolveNode = resolveNode;
function setAttributesAsText(params) {
    var name = params.name, text = params.text, nodeId = params.nodeId;
    var node = nodeManager_1.getNode(nodeId);
    if (name) {
        node.removeAttribute(name);
    }
    _1.default(node).attr(parseAttributes(text));
}
exports.setAttributesAsText = setAttributesAsText;
function setAttributeValue(params) {
    var nodeId = params.nodeId, name = params.name, value = params.value;
    var node = nodeManager_1.getNode(nodeId);
    node.setAttribute(name, value);
}
exports.setAttributeValue = setAttributeValue;
var history = [];
function setInspectedNode(params) {
    var node = nodeManager_1.getNode(params.nodeId);
    history.unshift(node);
    if (history.length > 5)
        history.pop();
    for (var i = 0; i < 5; i++) {
        evaluate_1.setGlobal("$" + i, history[i]);
    }
}
exports.setInspectedNode = setInspectedNode;
function setNodeValue(params) {
    var nodeId = params.nodeId, value = params.value;
    var node = nodeManager_1.getNode(nodeId);
    node.nodeValue = value;
}
exports.setNodeValue = setNodeValue;
function setOuterHTML(params) {
    var nodeId = params.nodeId, outerHTML = params.outerHTML;
    var node = nodeManager_1.getNode(nodeId);
    node.outerHTML = outerHTML;
}
exports.setOuterHTML = setOuterHTML;
function getDOMNodeId(params) {
    var node = params.node;
    return {
        nodeId: nodeManager.getOrCreateNodeId(node),
    };
}
exports.getDOMNodeId = getDOMNodeId;
function getDOMNode(params) {
    var nodeId = params.nodeId;
    return {
        node: nodeManager_1.getNode(nodeId),
    };
}
exports.getDOMNode = getDOMNode;
function parseAttributes(str) {
    str = "<div " + str + "></div>";
    return html_1.default.parse(str)[0].attrs;
}
function traverseNode(node, cb) {
    var childNodes = nodeManager.filterNodes(node.childNodes);
    for (var i = 0, len = childNodes.length; i < len; i++) {
        var child = childNodes[i];
        cb(child);
        traverseNode(child, cb);
    }
}
mutationObserver_1.default.on('attributes', function (target, name) {
    var nodeId = nodeManager_1.getNodeId(target);
    if (!nodeId)
        return;
    var value = target.getAttribute(name);
    if (isNull_1.default(value)) {
        connector_1.default.trigger('DOM.attributeRemoved', {
            nodeId: nodeId,
            name: name,
        });
    }
    else {
        connector_1.default.trigger('DOM.attributeModified', {
            nodeId: nodeId,
            name: name,
            value: value,
        });
    }
});
mutationObserver_1.default.on('childList', function (target, addedNodes, removedNodes) {
    var parentNodeId = nodeManager_1.getNodeId(target);
    if (!parentNodeId)
        return;
    addedNodes = nodeManager.filterNodes(addedNodes);
    removedNodes = nodeManager.filterNodes(removedNodes);
    function childNodeCountUpdated() {
        connector_1.default.trigger('DOM.childNodeCountUpdated', {
            childNodeCount: nodeManager.wrap(target, {
                depth: 0,
            }).childNodeCount,
            nodeId: parentNodeId,
        });
    }
    if (!isEmpty_1.default(addedNodes)) {
        childNodeCountUpdated();
        for (var i = 0, len = addedNodes.length; i < len; i++) {
            var node = addedNodes[i];
            var previousNode = nodeManager.getPreviousNode(node);
            var previousNodeId = previousNode ? nodeManager_1.getNodeId(previousNode) : 0;
            var params = {
                node: nodeManager.wrap(node, {
                    depth: 0,
                }),
                parentNodeId: parentNodeId,
                previousNodeId: previousNodeId,
            };
            connector_1.default.trigger('DOM.childNodeInserted', params);
        }
    }
    if (!isEmpty_1.default(removedNodes)) {
        for (var i = 0, len = removedNodes.length; i < len; i++) {
            var node = removedNodes[i];
            var nodeId = nodeManager_1.getNodeId(node);
            if (!nodeId) {
                childNodeCountUpdated();
                break;
            }
            connector_1.default.trigger('DOM.childNodeRemoved', {
                nodeId: nodeManager_1.getNodeId(node),
                parentNodeId: parentNodeId,
            });
        }
    }
});
mutationObserver_1.default.on('characterData', function (target) {
    var nodeId = nodeManager_1.getNodeId(target);
    if (!nodeId)
        return;
    connector_1.default.trigger('DOM.characterDataModified', {
        characterData: target.nodeValue,
        nodeId: nodeId,
    });
});
